import React, { useEffect, useRef } from 'react';
import { Box, Button, Paper, TextField, Typography } from '@mui/material';

const Composer = ({ value, onChange, onSend, onStop, streaming, disabled, maxChars }) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (!streaming && inputRef.current) inputRef.current.focus();
  }, [streaming]);

  const handleKeyDown = (event) => {
    // Enter sends, Shift+Enter breaks the line — the convention people already
    // have in their fingers from every other chat app.
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      if (!streaming && value.trim()) onSend();
    }
  };

  const overLimit = maxChars && value.length > maxChars;

  return (
    <Paper
      elevation={0}
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 3,
        p: 1.25,
        display: 'flex',
        alignItems: 'flex-end',
        gap: 1,
      }}
    >
      <TextField
        inputRef={inputRef}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Ask about competitors, campaigns or creators…"
        multiline
        maxRows={10}
        fullWidth
        disabled={disabled}
        variant="standard"
        InputProps={{ disableUnderline: true, sx: { fontSize: 15, px: 1, py: 0.5 } }}
      />

      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 0.5 }}>
        {overLimit ? (
          <Typography variant="caption" color="error">
            {`${value.length} / ${maxChars}`}
          </Typography>
        ) : null}
        {streaming ? (
          <Button variant="outlined" color="inherit" onClick={onStop} sx={{ minWidth: 88 }}>
            Stop
          </Button>
        ) : (
          <Button
            variant="contained"
            onClick={onSend}
            disabled={disabled || !value.trim() || overLimit}
            sx={{ minWidth: 88 }}
          >
            Send
          </Button>
        )}
      </Box>
    </Paper>
  );
};

export default Composer;
